
export const getTotalScore = (scorecardResult) => {
    let totalScore = 0;
    scorecardResult.sections.forEach((s) => {
        const totalSection = s.evaluationItems.reduce((acco, item) => acco + (item.score !== "" && item.score !== -1 && item.score !== -2 ? parseFloat(item.score) : 0), 0)
        totalScore = totalScore + totalSection
    })
    // Rounds the total score to two decimal place
    return parseFloat(totalScore.toFixed(2));
}

export const getTotalPoints = (scorecardResult) => {
    let totalPoints = 0;
    scorecardResult.sections.forEach((s) => {
        const totalSection = s.evaluationItems.reduce((acco, item) => acco + (item.score !== "" && item.score !== -1 && item.score !== -2 ? item.points : 0), 0)
        totalPoints = totalPoints + totalSection
    })
    // Rounds the total score to two decimal place
    return parseFloat(totalPoints.toFixed(2));
}

export const getRangeEvaluation = (scorecardResult, totalScore, totalPoints) => {
    let percentage = Math.round(totalScore / totalPoints * 100)
    if (isNaN(percentage)) {
        percentage = 0;
    }
    //return scorecardResult.settingItems.find(si => si.minRange <= percentage && si.maxRange >= percentage)
    return scorecardResult?.settingItems?.find(si => si.minRange <= percentage && si.maxRange >= percentage) ?? ""

}